<template>
    <h5 class="mb-4">Modificar Empresa</h5>

    <Form role="form" class="text-start" @submit="handleEditaEmpresa">

        <soft-field
            id="siglas"
            v-model="Siglas"
            type="text"
            label="Farmacia"
            placeholder="Indique las siglas de la farmacia"
            name="siglas"
            class="mb-4"
            :readonly="!rolPuedeEditar"/>

        <soft-switch id="indEscaneoFacturas" name="IndEscaneoFacturas" @change="cambiarEscaneo" :checked="IndEscaneoFacturas">
            Aplicar escaneado de facturas
        </soft-switch>

        <div class="text-center mt-5">
            <soft-button
                class="my-2 mb-2 text-sm"
                color="analiza-azul"
                full-width
                :is-disabled="!rolPuedeEditar"
                >
                <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Confirmar</span>
            </soft-button>
        </div>
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import SoftSwitch from "@/components/SoftSwitch.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";

  export default {
    name: "EditaEmpresaForm",
    components: {
        SoftField,
        SoftButton,
        SoftSwitch,
        Form,
    },
    props: {
        codigo: String,
        siglas: String,
        escaneoFacturas: String,
        puedeEditar: Boolean
    },
    data() {
        return {
            loading: false,
            Codigo: this.codigo,
            Siglas: this.siglas,
            IndEscaneoFacturas: this.escaneoFacturas=='S' ? true : false,
            rolPuedeEditar: this.puedeEditar,
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        cambiarEscaneo() {
            this.IndEscaneoFacturas=!this.IndEscaneoFacturas;
        },
        async handleEditaEmpresa() {
            if (!this.rolPuedeEditar) {
                showSwal.methods.showSwal({
                    type: "error",
                    message: "No dispone de permiso para modificar una empresa",
                    width: 500,
                });
                return;
            }

            this.loading = true;
            try {
                const payload = {
                    codigo: this.Codigo,
                    siglas: this.Siglas,
                    indEscaneoFacturas: this.IndEscaneoFacturas,
                };

                const resp = await this.$store.dispatch("farmacias/editaEmpresa", payload);

                if (resp.res == 'OK') {
                    showSwal.methods.showSwal({
                        type: "success",
                        message: "Se ha actualizado la empresa",
                        width: 600,
                    });

                    this.$emit('cerrar-modal');
                } else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: resp.mensaje,
                        width: 500
                    });
                }
            } catch (error) {
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Se ha producido un error",
                    width: 500,
                });
            } finally {
                this.loading = false;
            }
        },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>
